import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Box from '../Box/Box';
import { User } from '../Icon/Icons';

import './Avatar.css';

const SIZES = {
  xxSmall: 'xxSmall',
  xSmall: 'xSmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xLarge: 'xLarge',
  xxLarge: 'xxLarge',
};

function Avatar({ alt, src, size, children, className, dataTestId }) {
  const avatarClass = classnames('Avatar', `Avatar--${size}`, className);

  return (
    <Box className={avatarClass} dataTestId={dataTestId}>
      {src ? (
        <img className='Avatar-img' alt={alt} src={src} />
      ) : (
        children || <User />
      )}
    </Box>
  );
}

Avatar.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZES)),
  src: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

Avatar.defaultProps = {
  size: SIZES.small,
  alt: '',
  src: '',
  children: null,
  className: null,
  dataTestId: null,
};

export default Avatar;
